import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import registerServiceWorker from "./register-service-worker"

import "./config/rxjs-operators"

import App from "./App"

import { store } from "./store/configure-store"

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById("root")
)
registerServiceWorker()
